import { StyleSheet } from "@react-pdf/renderer";
import { PDF_COLORS } from "../CoveragePDF/CoveragePDF.styles";

export const styles = StyleSheet.create({
  view: {
    marginTop: 16,
    backgroundColor: PDF_COLORS.white,
  },
  heroBlock: {
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: PDF_COLORS.border,
    backgroundColor: PDF_COLORS.white,
    padding: 12,
    marginBottom: 12,
  },
  titleText: {
    fontSize: 16,
    fontWeight: "bold",
    color: PDF_COLORS.textStrong,
  },
  metaRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 10,
  },
  recColumn: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  recLine: {
    fontSize: 11,
    color: PDF_COLORS.text,
    marginBottom: 4,
  },
  scoreColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  scoreValue: {
    fontSize: 16,
    fontWeight: "bold",
    color: PDF_COLORS.textStrong,
  },
  scoreLabel: {
    fontSize: 9,
    color: PDF_COLORS.text,
    textTransform: "uppercase",
    marginTop: 2,
  },
  table: {
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: PDF_COLORS.border,
    backgroundColor: PDF_COLORS.white,
  },
  thead: {
    backgroundColor: PDF_COLORS.headerBg,
    padding: 8,
  },
  theadText: {
    fontSize: 12,
    fontWeight: "bold",
    color: PDF_COLORS.textStrong,
  },
  tbody: {
    padding: 10,
  },
  text: {
    fontSize: 11,
    color: PDF_COLORS.text,
  },
});
